import { aciToRGB } from "../config/aciToRGB";
import { Entity } from "../domain/types";

function isVeryLightColor(hex: string): boolean {
  // Remove # if present
  hex = hex.replace('#', '');
  // Expand short form
  if (hex.length === 3) hex = hex.split('').map(x => x + x).join('');
  if (hex.length !== 6) return false;
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  // Calculate perceived brightness
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  // Consider 'very light' if brightness > 220 or it's yellowish
  return brightness > 220 || (r > 200 && g > 200 && b < 100); // yellow
}

const getColor = (entity: Entity, theme: 'dark' | 'light' = 'dark'): string => {
  // Dark mode: preserve all original DXF colors
  if (theme === 'dark') {
    if (entity.color && entity.color > 256) {
      const r = (entity.color >> 16) & 0xFF;
      const g = (entity.color >> 8) & 0xFF;
      const b = entity.color & 0xFF;
      return `rgb(${r}, ${g}, ${b})`;
    }
    let colorIdx = entity.colorIndex || entity.color;
    if ((colorIdx === undefined || colorIdx === null) && entity.layer) {
      const layerColors: Record<string, number> = {
        '0': 7,
        'DEFPOINTS': 7,
        'CENTER': 1,
        'HIDDEN': 2,
        'OBJECT': 3,
        'ANNOTATION': 4,
        'DIMENSION': 5,
        'TEXT': 7
      };
      colorIdx = layerColors[entity.layer.toUpperCase()] || 7;
    }
    if (colorIdx === undefined || colorIdx === null) {
      return '#FFFFFF';
    }
    const positiveIdx = Math.abs(colorIdx);
    const color = aciToRGB[positiveIdx] || '#FFFFFF';
    return color;
  }

  // Light mode: replace only very light colors with black
  let color: string | undefined;
  if (entity.color && entity.color > 256) {
    const r = (entity.color >> 16) & 0xFF;
    const g = (entity.color >> 8) & 0xFF;
    const b = entity.color & 0xFF;
    color = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`.toUpperCase();
  } else {
    let colorIdx = entity.colorIndex || entity.color;
    if ((colorIdx === undefined || colorIdx === null) && entity.layer) {
      const layerColors: Record<string, number> = {
        '0': 7,
        'DEFPOINTS': 7,
        'CENTER': 1,
        'HIDDEN': 2,
        'OBJECT': 3,
        'ANNOTATION': 4,
        'DIMENSION': 5,
        'TEXT': 7
      };
      colorIdx = layerColors[entity.layer.toUpperCase()] || 7;
    }
    if (colorIdx === undefined || colorIdx === null) {
      color = '#FFFFFF';
    } else {
      const positiveIdx = Math.abs(colorIdx);
      color = (aciToRGB[positiveIdx] || '#FFFFFF').toUpperCase();
    }
  }
  if (color && isVeryLightColor(color)) {
    return '#082A43';
  }
  return color || '#082A43';
};

export default getColor;